import React from "react";
import clsx from "clsx";

import LoadingSpinner from "../../common/LoadingSpinner/LoadingSpinner";
import * as GlobalSelectors from "../../../store/Global/Global.selector";
import Text from "../../common/Text/Text";
import { StoreState } from "../../../store/RootReducer";
import { useSelector } from "../../../lib/hook/ReduxHooks";

const SpinnerOverlay = () => {
	const { message, visible } = useSelector((state: StoreState) =>
		GlobalSelectors.getLoadingOverlay(state),
	);

	return (
		<div
			className={clsx("SpinnerOverlay", visible && "--visible", "--pdf-ignore")}
		>
			<div className={"SpinnerOverlay__container"}>
				<LoadingSpinner visible={visible} />
				<br />
				<Text
					tag={"p"}
					className={clsx("SpinnerOverlay__message", visible && "--visible")}
				>
					{message}
				</Text>
			</div>
		</div>
	);
};

export default React.memo(SpinnerOverlay);
